import { Base, BaseResponseType, Response } from '@.api/methods';

import { BrandResponseType, BrandsResponseType, BrandsType } from './types';

export class Brands extends Base {
    public getAll(query?: { page?: number; per_page?: number; search?: string; is_archived?: boolean; has_image?: boolean }) {
        this.setPath('brands');
        if (query) this.setQuery(query);

        return this.getRequest() as Response<BrandsResponseType>;
    }

    public getById(id: number) {
        this.setPath('brands');
        this.setId(id);

        return this.getRequest() as Response<BrandResponseType>;
    }

    public create(data: BrandsType) {
        this.setPath('brands');
        this.setData(data);

        return this.postRequest();
    }

    public delete(id: number) {
        this.setPath('brands');
        this.setId(id);

        return this.deleteRequest();
    }

    public update(data: BrandsType, id: number) {
        this.setPath('brands');
        this.setId(id);
        this.setData(data);

        return this.putRequest();
    }

    public restore(id: number) {
        this.setPath('brands');
        this.setId(`${id}/restore`);

        return this.postRequest();
    }
}
